







































import { SXChoice } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WChoicesEditor extends BaseComponent {
	@Prop({ type: String, required: true })
	type!: string;

	@Prop({ type: Array, default: [] })
	choices!: SXChoice[];

	@Prop(Boolean)
	othersChoice!: Boolean;

	addChoice() {
		let c = new SXChoice();
		c.setUuid(this.ux_uuid());

		this.choices.push(c);
	}
	removeChoice(c: SXChoice) {
		let index = this.choices.indexOf(c);

		if (~index) {
			this.choices.splice(index, 1);
		}
	}
	isLastChoice(c: SXChoice) {
		let index = this.choices.indexOf(c);
		return index === this.choices.length - 1;
	}
	canRemove(c: SXChoice) {
		return this.choices.length > 1;
	}
	addNewChoiceInput(c: SXChoice) {
		if (this.isLastChoice(c)) {
			if (c.label.length) {
				this.addChoice();
			}
		}
	}
	created() {
		if (!this.choices.length) {
			this.addChoice();
		}
	}
}
